<!-- <p>status-comments works!</p> -->
<div class="timline-comments-wrapper">
  <div class="timline-center-wrap">
    <div
      [ngClass]="{
        'comments-container':
          screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,

        'comments-container-mobile': screenInfo == ScreenType.Mobile
      }"
    >
      <div class="post-card-content-actions">
        <div class="user-post-comment-container">
          <div class="warn-banner" *ngIf="isScrollError">
            <i>Scrolling error, Please check the comment id</i>
          </div>
          <div
            class="user-comment-wrapper"
            [ngClass]="{
              'zoom-in': comment.commentId === selectedCommentIdZoom
            }"
            *ngFor="let comment of post.postComments; let i = index"
          >
            <div class="user-avatar">
              <img
                [src]="
                  comment.isAuto == 'true'
                    ? userImage
                    : comment.commentUserProfile
                "
                alt="User Avatar"
              />
            </div>
            <div class="posted-comment-section">
              <div class="user-comment-posted">
                <div class="user-info">
                  <h4 class="user-name">
                    <b>{{
                      comment.isAuto == "true"
                        ? "AumYe"
                        : (comment.commentUsername | titlecase)
                    }}</b>
                  </h4>
                  <span class="post-time">{{
                    getFormattedDateTime(comment.commentAddDate)
                  }}</span>
                </div>
              </div>
              <div class="posted-comment-images" *ngIf="comment.isMultiple">
                <!-- <div *ngFor="let image of comment.parsedImages">
                  <img [src]="image.Url" alt="Comment Image" />
                </div> -->
                <div class="post-comment-evidence-url-container">
                  <div
                    *ngFor="let image of comment.parsedImages; let i = index"
                    style="display: flex; align-items: center"
                  >
                    {{ i + 1 + "." }}
                    <p>{{ image.FileName | truncateCase : 25 }}</p>
                    <mat-icon (click)="onShowEvidence(image)"
                      >open_in_new</mat-icon
                    >
                  </div>
                </div>
              </div>
              <div class="user-comment">
                {{ comment.commentText }}
                {{
                  comment.isAuto == "true"
                    ? "on " + getDateTimeCurrentTimezone(comment.commentAddDate)
                    : ""
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="content-action-buttons" *ngIf="false">
          <button (click)="focusTextarea()" mat-raised-button>
            <mat-icon>comment</mat-icon> Add Comment
          </button>
        </div>
        <div class="comment-section-container">
          <div class="user-avatar">
            <img [src]="loggedIsUsernameProfile" alt="User Avatar" />
          </div>
          <div class="comment-section">
            <div class="comment-input" (keydown)="onKeyDown($event)">
              <textarea
                #commentTextarea
                (input)="onCommentInputCheck()"
                [formControl]="commentControl"
                placeholder="Write a comment..."
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="2"
                [ngClass]="{ 'with-list': showUserList }"
              ></textarea>
              <mat-list *ngIf="showUserList" class="user-list">
                <mat-list-item
                  *ngFor="let user of filteredUserOrgList; let i = index"
                  (click)="selectUser(user)"
                  [ngClass]="{ active: i === selectedIndex }"
                >
                  {{ i + 1 }}. &nbsp; {{ user.firstname + " " + user.lastname }}
                </mat-list-item>
              </mat-list>
            </div>
            <div class="icon-buttons">
              <div>
                {{ selectedAttachment?.attachedContentName }}
              </div>
              <div>
                <button mat-icon-button (click)="fileInput1.click()">
                  <mat-icon class="input-icon">attach_file</mat-icon>
                </button>
                <input
                  type="file"
                  #fileInput1
                  style="display: none"
                  accept=".pdf,.jpeg,.png,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  (change)="onAttachmentSelected($event)"
                />
              </div>
              <div>
                <button
                  [disabled]="
                    !commentControl.value &&
                    !selectedAttachment?.attachedContentName
                  "
                  mat-icon-button
                  (click)="onCommentInput()"
                >
                  <mat-icon class="input-icon">send</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #OnZoomDialog>
  <mat-dialog-content style="max-height: -webkit-fill-available">
    <div class="on-zoom-image">
      <div *ngIf="isPdf && !pdfLoaded" class="loading-spinner">
        <mat-spinner></mat-spinner>
      </div>
      <img *ngIf="isImage" [src]="evidence" alt="No Event Evidence" />
      <pdf-viewer
        *ngIf="isPdf"
        [src]="evidence"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="true"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
        (after-load-complete)="onPdfLoad()"
        style="width: 100%; height: 550px"
      ></pdf-viewer>
      <app-excel-handler
        *ngIf="!isPdf && !isImage && !isDoc"
        [fileUrl]="evidence"
        (dataLoaded)="onDataLoaded($event)"
        style="width: 100%; height: 220px"
      >
      </app-excel-handler>
      <app-word-file-handler *ngIf="isDoc" [docxUrl]="evidence">
      </app-word-file-handler>
    </div>
  </mat-dialog-content>
</ng-template>
